import React from 'react'
import '../../assets/styles/components/errorFallback.scss'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface ErrorFallbackProps {
  error: Error
  resetErrorBoundary: () => void
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className='error-fallback-container' role='alert'>
      <div className='error-fallback-content'>
        <div className='icon'>💔</div>

        <h1 className='title'>{t('main.errorBoundaryTitle')}</h1>

        <p className='message'>{t('main.errorBoundaryMessage')}</p>

        <div className='error-details'>
          <h4 className='error-code'>Error Details:</h4>
          <pre className='error-text'>{error.message}</pre>
        </div>

        <div className='button-container'>
          <button className='retry-button' onClick={resetErrorBoundary}>
            {t('main.tryAgain')}
          </button>

          <button
            className='retry-button'
            onClick={() => {
              // navigation doesn't work because the router is not available
              navigate('/dashboard')
            }}
          >
            {t('main.goHome')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ErrorFallback
